define('components/handlers/company-index-updater',[
    'jquery',
    '../util/reload-fragments',
    '../handlers/analytics'
],function(
    jQuery,
    reload,
    analytics
){

    $.extend(companyInfo.handlers,{
        'company-index-updater': function(){
            var button = jQuery(this);
            var url = button.data("url") + '?setOpen=' + jQuery('#companyindex-scores').hasClass('panel-content-unconstrained');
            button.addClass('active').siblings().removeClass('active');
            analytics(['filter', 'click ' + button.text(), 'Company Index']);
            reload( button.data("reload-type"), url, null, true );
        }
    });

    $.extend(companyInfo.handlers,{
        'company-index-updater-disabled': function(){
            var miniloketBtn = jQuery('.miniloket-button');
            miniloketBtn.addClass('highlight');
            setTimeout(function() {
              miniloketBtn.removeClass('highlight');
            }, 750);
        }
    });
});

